const name = "HASTI 2022 Conference - Vived Learning"
export default name